import { formatPrice } from '@phoenix/helpers/price-helper';

export const getLocalizedPriceRangesFilterItems = (ranges, currencyByCountry = []) => {
  const country = window.Phoenix.currentCountry;
  const currency = currencyByCountry[country]?.currencyCode ?? window.Phoenix.currencyCode;

  if (!country || !currency) {
    return [];
  }

  return ranges.map((range, index) => {
    const from = (range.from?.exceptions?.[country] ?? range.from.default) || 0;
    const to = (range.to?.exceptions?.[country] ?? range.to.default) || Infinity;

    let translationKey = 'Filter.range.fromTo';

    if (from === 0) {
      translationKey = 'Filter.range.under';
    } else if (to === Infinity) {
      translationKey = 'Filter.range.above';
    }

    return {
      value: index,
      range: [from, to],
      label: window.Phoenix.i18n.t(translationKey, {
        from: formatPrice(from, currency, true),
        to: formatPrice(to, currency, true),
      }),
      trackingLabel: `price-range-${index}`,
    };
  });
};
